import { css } from 'styled-components';
import { fontFaces, figTreeFont } from './fonts';
import { cssDeclarations, vars } from '../theme';

export const globalCssVars = css`
    :root {
        ${cssDeclarations}
    }
`;

// Temporary rebrand CSS - hardcoded for feature flag
// (will be removed after rollout)
export const globalRebrandCssVars = css`
    [data-rebrand-new-fonts='true'] {
        --hb-fonts-body: ${figTreeFont};
        --hb-fonts-heading: ${figTreeFont};
        --hb-fonts-display: ${figTreeFont};
    }
`;

export const hbuiGlobalStyles = css`
    ${fontFaces}
    ${globalCssVars}
    ${globalRebrandCssVars}

    html,
    body {
        font-family: ${vars.fonts.body};
    }
`;

// Re-export for convenience
export { fontFaces };
